var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.module.use)?_c('Button',{attrs:{"text":_vm.buttonText,"type":"download"},on:{"action":function($event){return _vm.onCsvDownload()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }